export const CONTENTS = {
  SmartthingsSettings: 'SMARTTHINGS_SETTINGS',
  SmartthingsAddDevice: 'SMARTTHINGS_ADD_DEVICE',
  SmartthingsViewDevice: 'SMARTTHINGS_VIEW_DEVICE',
  AddUser: 'ADD_USER',
  ViewUser: 'VIEW_USER',
  SMS: 'SMS',
  CRON: 'CRON',
  NOTIFICATION: 'NOTIFICATION',
  UPS: 'UPS',
  GPIO: 'GPIO',
};
